/**************************************************************************
Name:         admin.js
Description:  Site administration scripting.
Date Created: 12/05/2013 by Kyle Brickman
Modified:     07/06/2015 by Roxanne Dunn - converting side nav to slide out nav
**************************************************************************/

/* Displays site navigation dropdown if wireless */
loadEvents[loadEvents.length] = function( ){
	var resizeNavigationTimer;

	if( !$( 'html' ).hasClass( 'frame' ))
		try
		{
			if( top.location.href != self.location.href )
				throw new Error( 'Page cannot be viewed in iframe' )
				//1 = 2;
		}
		catch( e )
		{
			top.location.href = self.location.href;
		}

	$( 'body' ).on( 'click', function( ){
		$( 'nav' 		  ).removeClass( 'active' );
		// $( 'nav div.user' ).removeClass( 'active' );
		// $( 'a.user'   	  ).removeClass( 'active' );
		$( 'a.menu'   	  ).removeClass( 'active' );
		resizeNavigationTimed( );
	});

	$( 'nav a.menu' ).on( 'click', function( evt ){
		evt.preventDefault( );
		evt.stopPropagation( );

		$( 'nav'    ).toggleClass( 'active' );
		$( 'a.menu' ).toggleClass( 'active' );

		// $( 'a.user'   ).removeClass( 'active' );
		// $( 'div.user' ).removeClass( 'active' );
		resizeNavigationTimed( );
	});

	// $( 'nav a.user' ).on( 'click', function( evt ){
	// 	evt.preventDefault( );
	// 	evt.stopPropagation( );

	// 	//$( 'nav'      ).toggleClass( 'activeUser' );
	// 	$( 'a.user'   ).toggleClass( 'active' 	  );
	// 	$( 'div.user' ).toggleClass( 'active' 	  );

	// 	$( 'a.menu'   ).removeClass( 'active' );
	// 	$( 'nav' 	  ).removeClass( 'active' );
	// });

	$( 'a.parentNav' ).not( 'a.siteadmin' ).on( 'click', function( evt ) {
		evt.preventDefault( );
		evt.stopPropagation( );

		$( this ).toggleClass( 'open'  );
		$( this ).next( 'div.childNav' ).toggleClass( 'open' );

		setTimeout( resizeNavigationTimed, 500 );
	});

	// $( 'div.topControls a.account' ).on( 'click', function( evt ) {
	// 	evt.stopPropagation( );
	// 	$( 'div.controlWrapper' ).toggleClass( 'active' );
	// });

	// $( document ).on( 'click', function( ) {
	// 	$( 'div.controlWrapper' ).removeClass( 'active' );
	// });

	var resizeNavigation = function( )
	{
		var parentNav   = $( 'nav' ),
			navigation  = $( 'nav div.menu div.wrapper' ),
			scrollPos   = $( 'nav div.menu div.wrapper' ).scrollTop( ),
			sideNavIcon = $( 'nav a.sidebarMenu' );

		navigation.removeClass( 'scroll' ).css( 'height', '' );

		var viewportHeight   = $( window ).height( ) - 200,
			navigationHeight = navigation.height( ),
			bodyHeight       = $( 'body' ).height( ),
			contentHeight    = $( 'article.mainBody' ).outerHeight( ),
			heightToUse      = bodyHeight;

		if( parentNav.css( 'position' ) == 'fixed' ){
			//mobile nav
			parentNav.css( 'min-height', '0' );
			if( navigationHeight > viewportHeight )
				navigation.addClass( 'scroll' ).height( viewportHeight );
			$( 'nav div.menu div.wrapper' ).scrollTop( scrollPos );
		} else {
			//side nav
			if( contentHeight > heightToUse ) heightToUse = contentHeight;
			$( 'nav' ).css( 'min-height', heightToUse.toString() + 'px' );
		}
	}
	var resizeNavigationTimed = function( )
	{
		clearTimeout( resizeNavigationTimer );
		resizeNavigationTimer = setTimeout( function(){ resizeNavigation() }, 500 );
	}

	$( window ).on( 'orientationchange resize tabContainer.load', function( ) {
		resizeNavigationTimed( ); 
	});
	resizeNavigationTimed( );

	var resizeReadOnly = function( ) {
		$( 'div.readonlyL' ).each( function( ) {
			var label		= $( this )
			var infoText	= label.next( 'div.readonlyR' );
			var leftHeight  = label.height( );
			var rightHeight = infoText.height( );

			if( leftHeight > rightHeight ) infoText.css( 'height', leftHeight + 'px' );
		});
		
	}
	$( window ).on( 'orientationchange resize', resizeReadOnly );
	resizeReadOnly( );

	$( 'body' ).on( 'click', '#breadcrumb li.tabLink a', function( evt ) {
		evt.preventDefault( );

		var index = $( this ).parent( ).index( );

		$( '#breadcrumb li:gt(' + index + ')' ).remove( );

		$( 'iframe' ).attr( 'src', $( this ).attr( 'href' ) );
	});

	var writeSidebarSessionStorage = function( isNavOpen )
	{
		$.ajax({
			url      : '/cfcs/respond.cfc',
			cache    : false,
			dataType : 'json',
			data     : {
				method : 'setBackOfficeSidebarStateByAJAX',
				isOpen : isNavOpen
			}
		});
	};

	$( 'nav#sidebar a.sidebarMenu' ).click(function(event) {
		$( 'nav#sidebar' ).toggleClass( 'open' );
		$( '.mainBody' ).toggleClass( 'open' );

		writeSidebarSessionStorage( $( 'nav#sidebar' ).hasClass( 'open' ) );
	});

	var expandRollup = function( ) {
		var pagination 		= $( 'div.paginatedTable div.pagination.upper' ),
			pageRight  		= pagination.find( $( 'div:not(.rollup,.attention,.showHide,.rollupBlock,.recordCount,.column)' )),
			chevron    		= pagination.find( $( 'span.chevron'  )),
			attention  		= pagination.find( $( 'div.attention' )),
			showHide   		= pagination.find( $( 'div.showHide'  )),
			table 			= $( 'div.paginatedTable' ).find( 'table.isResponsive' ),
			attentionHeight = parseInt( attention.attr( 'data-height' )),
			showHideHeight  = parseInt( showHide.attr(  'data-height' )),
			pageRightHeight = pageRight.height( ),
			isActive   		= showHide.hasClass( 'active' );

		if( $( window ).width( ) <= 768 ) { 
			var paginationHeight  = isActive ? attentionHeight + 32 : attentionHeight + showHideHeight + 32;
			var expandMarginTop   = 0;
			var collapseMarginTop = 0;
		} else {
			var paginationHeight  = isActive ? attentionHeight : attentionHeight + showHideHeight;
			var expandMarginTop   = attentionHeight > pageRightHeight ? attentionHeight + showHideHeight - pageRightHeight : showHideHeight;
			var collapseMarginTop = attentionHeight > pageRightHeight ? attentionHeight - pageRightHeight : 0;
		}

		var tableTop = paginationHeight + 10;

		showHide.toggleClass( 'active' );
		 chevron.toggleClass( 'active' );

		pagination.css( 'height', paginationHeight + 'px' );
			 table.css( 'top', 	  tableTop + 'px'  );

		if( !isActive ) { 
			showHide.css({ 'height' : showHideHeight + 'px' });
			pageRight.css({ 'margin-top' : expandMarginTop + 'px' });
			chevron.attr( 'title', 'Collapse' );
		} else {
			showHide.css({ 'height' : '0' });
			pageRight.css({ 'margin-top' : collapseMarginTop + 'px' });
			chevron.attr( 'title', 'Expand' );
		}
	}

	$( 'body' ).on( 'click', 'div.paginatedTable div.pagination span.chevron', expandRollup );

	//Format dollar on key up
	
	var formatCommas = function( inputVal )
	{ 
		var x = inputVal;
	    return x.toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");	
	};	
	
	$(document).on('keyup', 'input.dollarSign', function() {
	    var x = $(this).val();
	    $(this).val( formatCommas( x ) );
	}); 

//end load events
}

var setRollupWidths = function( ) {
	$( 'div.paginatedTable div.pagination div.attention div.rollupBlock' ).css( 'width', 'auto' );
	$( 'div.paginatedTable div.pagination div.showHide  div.rollupBlock' ).css( 'width', 'auto' );

	$( 'div.paginatedTable div.pagination div.attention div.rollupBlock' ).each( function( ) {
		var attention = $( this ),
			index 	  = attention.index( ) + 1;
			showHide  = $( 'div.paginatedTable div.pagination div.showHide div.rollupBlock:nth-child(' + index + ')' ),
			attentionWidth = attention.width( ),
			showHideWidth  = showHide.width( );

		var blockWidth = attentionWidth < showHideWidth ? parseInt( showHideWidth ) + 5 : parseInt( attentionWidth ) + 5;

		attention.css( 'width', blockWidth + 'px' );
		showHide.css(  'width', blockWidth + 'px' );
	});
}

var setRollup = function( ) {
	var pagination = $( 'div.paginatedTable div.pagination.upper.admin' ),
		pageRight  = pagination.find( $( 'div:not(.rollup,.attention,.showHide,.rollupBlock,.recordCount,.column)' )),
		attention  = pagination.find( $( 'div.attention' )),
		showHide   = pagination.find( $( 'div.showHide'  )),
		chevron    = pagination.find( $( 'span.chevron'  )),
		table 	   = $( 'div.paginatedTable' ).find( 'table.isResponsive' ),
		isActive   = showHide.hasClass( 'active' ),
		attentionHeight = attention.height( ) - 1,
		pageRightHeight = pageRight.height( );

	if( !attention.length ) {
		pagination.css( 'height', '32px' );
	}
	else {
		setRollupWidths( );

		attention.attr( 'data-height', attentionHeight );

		showHide.css( 'height', 'auto' );
		var showHideHeight = parseInt( showHide.height( )) - 1;

		if( $( window ).width( ) <= 768 ) {
			var expandMarginTop   = 0;
			var collapseMarginTop = 0;
		} else {
			var expandMarginTop   = attentionHeight > pageRightHeight ? attentionHeight + showHideHeight - pageRightHeight : showHideHeight;
			var collapseMarginTop = attentionHeight > pageRightHeight ? attentionHeight - pageRightHeight : 0;
		}

		if( isActive ) {
			showHide.attr( 'data-height', showHideHeight ).css( 'height', showHideHeight );
			pageRight.css({ 'margin-top' : expandMarginTop + 'px'  });
			chevron.attr( 'title', 'Collapse' );

			if( $( window ).width( ) <= 768 ) {
				var paginationHeight = parseInt( attention.attr( 'data-height' )) + parseInt( showHide.attr( 'data-height' )) + 32;
			} else {
				var paginationHeight = parseInt( attention.attr( 'data-height' )) + parseInt( showHide.attr( 'data-height' ));
			}
		}
		else {
			showHide.attr( 'data-height', showHideHeight ).css( 'height', 0 );
			pageRight.css({ 'margin-top' : collapseMarginTop + 'px'  });
			chevron.attr( 'title', 'Expand' );

			if( $( window ).width( ) <= 768 )
				var paginationHeight = parseInt( attention.attr( 'data-height' )) + 32;
			else
				var paginationHeight = parseInt( attention.attr( 'data-height' ));
		}

		paginationHeight = paginationHeight || 0;

		pagination.css( 'height', paginationHeight + 'px' );

		var tableTop = paginationHeight + 10;
		table.css( 'top', tableTop + 'px' );
	}
}

var disableForm = function( formID, redactorSelectors ) {
	var form = $( 'form#' + formID ),
		redactors = $( redactorSelectors ).not( '.keepEnabled' );

	form.find( ':input' ).not( '.keepEnabled' ).prop( 'disabled', true );
	//redactors.redactor( 'destroy' );
	form.on( 'submit', function( evt ){ evt.preventDefault(); return false; } );
}

/* Correspondence Scripts */
var writeScriptButtons = function( categoryUUID ) {
	$.ajax({
		url      : '/cfcs/correspondenceGW.cfc',
		data     : {
			method    	 : 'getScriptAJAX',
			categoryUUID : categoryUUID
		},
		cache    : false,
		dataType : 'json',
		success  : function( results )
		{		
			$( 'div.buttonContainer' ).html( '' );

			if( results.length )
			{
				for( var i = 0; i < results.length; i++ ) 
				{
					$( 'div.buttonContainer' ).append( '<input type = "button" id = "' + results[i].scriptUUID + '" value = "' + results[i].titleShort + '" /> ' );
				}

				resizeFieldsets( );
			}
		}
	});
}